export default __webpack_public_path__ + "static/media/tinkercad.e92e3e66.png";